import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import './App.css';
import './service/css/Acp.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import LoginPage from './service/LoginPage';
import MonitoramentoPublico from './service/MonitoramentoPublico';
import MonitoramentoInterno from './service/MonitoramentoInterno';
import Home from './service/Home';
import Usuarios from './service/Usuarios';
import SelecionaEntidade from './service/SelecionaEntidade';
import UsuariosVinculos from './service/Vinculos';
import Associacoes from './service/Associacoes';
import Pessoa from './service/Pessoa';
import Pessoas from './service/Pessoas';
import Ata from './service/Ata';
import UploadTemplate from './service/UploadTemplate';
import Favorecidos from './service/Favorecidos';
import Despesas from './service/Despesas';
import UploadImagem from './service/UploadImagem';
import Programas from './service/Programas';
import FonteRecursos from './service/FonteRecursos';
import ElementoDespesas from './service/ElementoDespesas';
import Acoes from './service/Acoes';
import Orcamentos from './service/Orcamentos';
import SubAcoes from './service/SubAcoes';
import Itens from './service/Itens';
import SaldoOrcamentarioPage from './service/SaldoOrcamentarioPage';
import PessoaDependentes from './service/PessoaDependentes';
import Contas from './service/Contas';
import Rendimentos from './service/Rendimentos';
import Saldos from './service/Saldos';
import SaldosInvestimento from './service/SaldosInvestimento';
import Bancos from './service/Bancos';
import Receitas from './service/Receitas';
import Redistribuicoes from './service/Redistribuicoes';
import Redistribuicao from './service/Redistribuicao';
import MovimentoMensal from './service/MovimentoMensal';
import MovimentoAnual from './service/MovimentoAnual';
import ConciliacaoBancaria from './service/ConciliacaoBancaria';
import ExecucaoOrcamentaria from './service/ExecucaoOrcamentaria';
import SessionsAtivas from './service/SessionsAtivas';
import ContaProgramaManagement from './service/ContaProgramaManagement';

function App() {
  const [globalError, setGlobalError] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      setGlobalError(e.detail?.message || 'Erro inesperado.');
      setTimeout(() => setGlobalError(null), 6000);
    };
    window.addEventListener('app:error', handler);
    return () => window.removeEventListener('app:error', handler);
  }, []);

  return (
    <Router>
      {globalError && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
          padding: '12px 20px', background: '#dc3545', color: '#fff',
          textAlign: 'center', fontWeight: 500, fontSize: '14px'
        }}>
          {globalError}
        </div>
      )}
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/monitoramento" element={<MonitoramentoPublico />} />
        <Route path="/monitoramento-interno" element={<MonitoramentoInterno />} />
        <Route path="/home" element={<Home />} />
        <Route path="/usuarios" element={<Usuarios />} />
        <Route path="/seleciona_entidade" element={<SelecionaEntidade />} />
        <Route path="/usuario_vinculos" element={<UsuariosVinculos />} />
        <Route path="/associacoes" element={<Associacoes />} />
        <Route path="/pessoa" element={<Pessoa />} />
        <Route path="/pessoas" element={<Pessoas />} />
        <Route path="/ata" element={<Ata />} />
        <Route path="/templates" element={<UploadTemplate />} />
        <Route path="/favorecidos" element={<Favorecidos />} />
        <Route path="/imagens" element={<UploadImagem />} />
        <Route path="/despesas" element={<Despesas />} />
        <Route path="/programas" element={<Programas />} />
        <Route path="/fonte_recursos" element={<FonteRecursos />} />
        <Route path="/elemento_despesas" element={<ElementoDespesas />} />
        <Route path="/acoes" element={<Acoes />} />
        <Route path="/orcamentos" element={<Orcamentos />} />
        <Route path="/sub_acoes" element={<SubAcoes />} />
        <Route path="/itens" element={<Itens />} />
        <Route path="/saldo-orcamentario" element={<SaldoOrcamentarioPage />} />
        <Route path="/pessoa_dependentes" element={<PessoaDependentes />} />
        <Route path="/contas" element={<Contas />} />
        <Route path="/rendimentos" element={<Rendimentos />} />
        <Route path="/saldos" element={<Saldos />} />
        <Route path="/saldos-investimento" element={<SaldosInvestimento />} />
        <Route path="/bancos" element={<Bancos />} />
        <Route path="/receitas" element={<Receitas />} />
        <Route path="/redistribuicoes" element={<Redistribuicoes />} />
        <Route path="/redistribuicao" element={<Redistribuicao />} />
        <Route path="/redistribuicao/:id" element={<Redistribuicao />} />
        <Route
          path="/redistribuicao/operacao/:ano/:operacaoId"
          element={<Redistribuicao />}
        />
        <Route path="/movimento-mensal" element={<MovimentoMensal />} />
        <Route path="/movimento-anual" element={<MovimentoAnual />} />
        <Route path="/conciliacao-bancaria" element={<ConciliacaoBancaria />} />
        <Route path="/execucao_orcamentaria" element={<ExecucaoOrcamentaria />} />
        <Route path="/sessions-ativas" element={<SessionsAtivas />} />
        <Route path="/contas/programas" element={<ContaProgramaManagement />} />
      </Routes>
    </Router>
  );
}

export default App;
